import "./App.css";
import { Routes, Route } from "react-router-dom";
import Register from "../src/pages/Register/Register";
import Login from "./pages/Login/Login";
import Form from "./pages/Form/Form";
import ForgotPassword from "./pages/Login/ForgotPassword";
import Dashboard from "../src/utils/components/Admin/Dashboard";
import ResetPassword from "./pages/Login/ResetPassword";
import NotFoundPage from "./pages/NotFound/NotFound";
import DraftForm from "../src/pages/Form/DraftForm";
import SubscriptionPlans from "../src/pages/Subscription/SubscriptionPlans";
import SubscriptionDetails from "./pages/Subscription/SubscriptionDetails";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Form />} />
      <Route path="/form" element={<Form />} />
      <Route path="/register" element={<Register />} />
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="*" element={<NotFoundPage />} />
      <Route path="/draft-form/:draftId" element={<DraftForm />} />
      <Route exact path="/admin/dashboard" element={<Dashboard />} />
      <Route path="/subscription-plans" element={<SubscriptionPlans />} />
      <Route path="/subscription-details" element={<SubscriptionDetails />} />
    </Routes>
  );
}

export default App;
